<template>
  <div>
    <Head title="Dërgesat"/>

    <h1 class="mb-8 text-3xl font-bold">Dërgesat</h1>

    <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">

      <div  class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/2 -mb-4">

        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
          <label class="block text-gray-700">Biznesi shitës:</label>
          <select v-model="form.business_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="business in businesses" :value="business.id">{{ business.name }}</option>
          </select>

          <label class="block text-gray-700">Shteti:</label>
          <select v-model="form.country_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
          </select>

          <label class="block text-gray-700">Qyteti:</label>
          <select v-model="form.city_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="city in selectedCities" :value="city.id">{{ city.name }}</option>
          </select>

          <label class="block text-gray-700">Pika marrëse:</label>
          <select v-model="form.location_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="location in selectedLocations" :value="location.id">{{ location.name }}</option>
          </select>

        </search-filter>

        <input class="relative px-6 py-3 w-1/2 rounded-r focus:shadow-outline mt-3 lg:mt-0" autocomplete="off" type="text" placeholder="Kërko me ID" v-model="form.id" @input="$emit('update:modelValue', $event.target.value)" />
      </div>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label text-gray-700">Statusi:</label>
        <Multiselect
          v-model="form.status_ids"
          :options="filterStatuses.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />

      </div>

    </div>


    <div v-if="currentSelections != null && currentSelections.length !== 0" class="flex flex-wrap lg:flex-nowrap mb-6 lg:mb-3 items-center">
      <dropdown class="mt-1" placement="bottom-end">
        <template #default>
          <icon name="print" class="mr-2 w-6 h-6"></icon>
        </template>
        <template #dropdown>
          <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
            <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.pdf.multiple',{orderIds: currentSelections})" target="_blank">Printo PDF</a>
            <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.sticker.8x5.multiple',{orderIds: currentSelections})" target="_blank">Printo Stiker 8x5cm</a>
            <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.sticker.10x7.multiple',{orderIds: currentSelections})" target="_blank">Printo Stiker 10x7cm</a>
          </div>
        </template>
      </dropdown>


      <select-input v-model="selectedStatus" class="px-6" label="Ndrysho statusin">
        <option v-for="status in statusesForMultipleUpdate" :key="status.id" :value="status.id">{{ status.name }}</option>
      </select-input>
    </div>


    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">
            <input :checked="allSelected" @click="selectAll" class="flex items-center  px-2 py-4" type="checkbox">
          </th>
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">Statusi</th>
          <th class="pb-4 pt-6 px-2">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-2">Pika marrëse</th>
          <th class="pb-4 pt-6 px-2">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-2">Produkti</th>
          <th class="pb-4 pt-6 px-2">Sasia</th>
          <th class="pb-4 pt-6 px-2">Madhësia e pakos</th>
          <th class="pb-4 pt-6 px-2">Çmimi</th>
          <th class="pb-4 pt-6 px-2">Posta</th>
          <th class="pb-4 pt-6 px-2">Qyteti</th>
          <th class="pb-4 pt-6 px-2">Krijuar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-2">
            <input v-model="order.selected" :value="order.id" class="flex items-center  px-2 py-4" type="checkbox">
          </td>

          <td class="w-px border-t px-2">
            <Link class="flex items-center  px-2 py-4" :href="`dergesat/${order.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>

          <td class="border-t px-2">
              {{ order.id }}
              <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>
              <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>
              <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getStatusColor(order.status.id)">
                {{ order.status.name }}</span>
          </td>
          <td class="border-t px-2">
              {{ order.business.name }}
          </td>
          <td class="border-t px-2">
              {{ order.location.name }}
          </td>
          <td class="border-t px-2">
              {{ order.name }}
          </td>
          <td class="border-t px-2">
              {{ order.phone }}
          </td>
          <td class="border-t px-2">
              {{ order.product_name }}
          </td>
          <td class="border-t px-2">
              {{ order.quantity }}
          </td>
          <td class="border-t px-2">
              {{ order.package_size.name }}
          </td>
          <td class="border-t px-2">
              {{ order.product_price }}
          </td>
          <td class="border-t px-2">
              {{ order.shipping_price }}
          </td>

          <td class="border-t px-2">
              {{ order.city.name }}
          </td>
          <td class="border-t px-2">
              {{ order.hr_created_at }}
          </td>
          <td class="w-px border-t">

            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <icon name="three-dots" class="block w-12 h-6 fill-gray-400"/>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.pdf',{order: order.id})" target="_blank">Printo PDF</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.sticker.8x5',{order: order.id})" target="_blank">Printo Stiker 8x5cm</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.order.sticker.10x7',{order: order.id})" target="_blank">Printo Stiker 10x7cm</a>

                </div>
              </template>
            </dropdown>


          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap">
      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12"
      >
        <option v-if="orders.meta.total > 15" value="15">15 / {{orders.meta.total}}</option>
        <option v-if="orders.meta.total > 30"  value="30">30 / {{orders.meta.total}}</option>
        <option v-if="orders.meta.total > 50"  value="50">50 / {{orders.meta.total}}</option>
        <option v-if="orders.meta.total > 100"  value="100">100 / {{orders.meta.total}}</option>
        <option :value="orders.meta.total">{{orders.meta.total}} / {{orders.meta.total}}</option>
      </select-input>
      <pagination class="mt-6" :links="orders.meta.links"/>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import axios from 'axios'
import Dropdown from '@/Shared/Dropdown'
import {computed} from 'vue'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown,
    FileInput,
    Modal,
    LoadingButton,
    SelectInput,
    Multiselect
  },
  layout: Layout,
  props: {
    orders: Object,
    filters: Object,
    countries: Object,
    cities: Object,
    locations: Object,
    businesses: Object,
    statuses: Object,
    statusesForMultipleUpdate: Object
  },
  data() {
    return {
      form: {
        id: null,
        search: this.filters.search,
        country_id: this.filters.country_id,
        city_id: this.filters.city_id,
        location_id: this.filters.location_id,
        business_id: this.filters.business_id,
        status_ids: this.filters.status_ids,
        per_page: this.orders.meta.total < 15 ? this.orders.meta.total : this.orders.meta.per_page
      },
      filterStatuses: {
        options: this.statuses.map(function(status){
          return {value: status.id, label: status.name}
        }),
      },
      selectedCities: this.cities,
      selectedLocations: this.locations,
      currentSelections: null,
      selectedStatus: this.statusesForMultipleUpdate[0].id

    }
  },
  mounted() {
    this.orders.data.forEach((order) => order['selected'] = false);
  },
  computed:{
    allSelected(){
      return this.orders.data.every(order => order.selected)
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('dergesat', pickBy(this.form), {preserveState: true})
      }, 150),
    },
    orders: {
      handler() {
        this.currentSelections = this.orders.data
          .filter( order => order.selected )
          .map( order => order.id )
          .toString();
      },
      deep: true
    },
    'form.country_id'(){
      this.getCities()
    },
    'form.business_id'(){
      this.getLocations()
    },
    selectedStatus(newValue){
      this.updateStatusMultiple(newValue)
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  methods: {
    updateStatusMultiple(statusId){
      this.$inertia.put('/shofer-mbledhes/dergesat/status/multiple',{orderIds: this.currentSelections, status_id: statusId})
    },
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    selectAll(){
      let allS = this.allSelected;
      this.orders.data.forEach(order => order.selected = !allS)
    },
    getCities(){
      let self = this
      self.selectedCities = []
      axios.get('/ajax/list/cities',{
        params: {
          country_id: this.form.country_id,
        }
      }).then(function (result){
        self.selectedCities = result.data.cities;
      });
    },
    getLocations(){
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations',{
        params: {
          business_id: this.form.business_id,
        }
      }).then(function (result){
        self.selectedLocations = result.data.locations;
      });
    },
    getStatusColor(orderId){
      let statusColor = 'bg-indigo-500'
      if(orderId === 1)
        statusColor = 'bg-yellow-500'

      if(orderId === 3)
        statusColor = 'bg-orange-500'

      if(orderId === 4)
        statusColor = 'bg-indigo-900'

      if(orderId === 5)
        statusColor = 'bg-green-500'

      if(orderId === 6)
        statusColor = 'bg-yellow-700'

      if(orderId === 7)
        statusColor = 'bg-red-500'

      if(orderId === 8)
        statusColor = 'bg-gray-400'

      if(orderId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    }
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
